import {
  Color,
  HoodDuctCoverFinish,
  HoodDuctCoverHeight,
  HoodInsertChoice,
  HoodModelNumber,
  Trim,
} from './Enums';
import { hoodInsertModel } from './hoodInsertModel';

export class HoodState {
  // This is the initial state of the Lacanche hood

  /**
   * Whether a hood is selected or not
   * @type {boolean}
   */
  isSelected = false;

  /**
   * The model number of the hood
   * @type {string}
   */
  modelNumber = HoodModelNumber.LH1600;

  /**
   * The color of the hood (too many to list)
   * @type {string}
   */
  color = Color.matteBlack;

  /**
   * The trim of the Lacanche logo
   * @type {string}
   */
  trim = Trim.brass;

  /**
   * The height of the duct cover (250, 500, 750, or 1000mm)
   * @type {string}
   */
  ductCoverHeight = HoodDuctCoverHeight.twoFifty;

  /**
   * The finish of the duct cover (stainlessSteel or color)
   * @type {string}
   */
  ductCoverFinish = HoodDuctCoverFinish.stainlessSteel;

  /**
   * The chosen hood insert
   * @type {string}
   */
  insertChoice = HoodInsertChoice.ventAHoodMagicLung;

  /**
   * The hood insert model
   * @type {?string}
   */
  get insertModel() {
    return hoodInsertModel(this.modelNumber, this.insertChoice);
  }

  /**
   * Is this hood created from a configuration URL?
   * @type {boolean}
   */
  isConfigured = false;

  /**
   * Set up the state of the range from a previously configured range
   *
   * @param {object} configuredHood
   * @param {string} configuredHood.modelNumber
   * @param {string} configuredHood.color
   * @param {string} configuredHood.trim
   * @param {string} configuredHood.dcHeight
   * @param {string} configuredHood.dcFinish
   * @param {string} configuredHood.insertChoice
   */
  setState(configuredHood) {
    this.isConfigured = true;
    this.isSelected = true;

    if (Object.values(HoodModelNumber).includes(configuredHood.modelNumber)) {
      this.modelNumber = configuredHood.modelNumber;
    } else {
      this.modelNumber = HoodModelNumber.LH1600;
      return;
    }

    if (Object.values(Color).includes(configuredHood.color)) {
      this.color = configuredHood.color;
    }

    if (Object.values(Trim).includes(configuredHood.trim)) {
      this.trim = configuredHood.trim;
    }

    if (Object.values(HoodDuctCoverHeight).includes(configuredHood.dcHeight)) {
      this.ductCoverHeight = configuredHood.dcHeight;
    }

    if (Object.values(HoodDuctCoverFinish).includes(configuredHood.dcFinish)) {
      this.ductCoverFinish = configuredHood.dcFinish;
    }

    if (Object.values(HoodInsertChoice).includes(configuredHood.insertChoice)) {
      this.insertChoice = configuredHood.insertChoice;
    }
  }

  /**
   * The slug for a fully configured hood.
   * @returns {string}
   */
  slug() {
    let slug =
      this.modelNumber +
      '-' +
      this.color +
      '-' +
      this.trim +
      '-' +
      this.ductCoverHeight +
      '-' +
      this.ductCoverFinish +
      '-' +
      this.insertChoice;

    return slug.replace(/null/g, '').replace(/-+$/, '');
  }
}
